import Images from './images';

const leaderboardDataSet1 = [
  '634573bc070ee2010f654b1f:Arun:0',
  '2526',
  '6306163f3b20cd001e7d2e38:F Khan:0',
  '927',
  '6309c4af3b20cd001e7f463c:Raja Singh:8',
  '662'
];
const leaderboardDataSet2 = [
  '63b98838a2c46a001dadea81:Zara:1',
  '435',
  '6334d27171e5750f87756b82:Ram Prabhu:0',
  '385',
  '63bb1666a2c46a001dae559c:Lakshman:0',
  '372'
];
const leaderboardDataSet3 = [
  '6398b8b96d9419001eabbef1:Ramya:0',
  '252',
  '63badce5a2c46a001dae3bc6:Krishna:0',
  '188',
  '63ba8f71a2c46a001dae2d3e:Ramandeep singh:6',
  '150'
];

const winningsDataSet1 = {
  winningsAmount: 200000,
  winningsPerPosition: {
    '1': {
      '10000': 1,
      '20000': 2,
      '50000': 1,
      '100000': 1
    }
  }
};
const cardsGame: any = [
  {
    gameName: 'Poker',
    gameImage: Images.pokerImg,
    gameBackgroundImgUrl: Images.pokerBg,
    contest: {
      filledTeamSlots: '6,678'
    },
    bgImgSrc: Images.pokerPosterBg,
    titleImgSrc: Images.pokerPosterTitle,
    gameImgSrc: Images.pokerPosterGameImg,
    game: 'poker',
    gameDescription1: 'Play your cards right & ',
    gameDescription2: 'hit the jackpot in Poker!'
  }
];

const carRace = {
  gameName: 'Car Race',
  gameImage: Images.carRaceMinigamePortrait,
  gameImageLandscape: Images.carRaceMinigameLandscape,
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/car_race/car_race_p_bg.webp',
  gameURL: 'https://games-dev.igamio.com/car_race/',
  leaderboard: leaderboardDataSet1,
  gameId: '6348f647efbad4001e692879',
  gameSlug: 'car-race',
  contest: {
    _id: '63b281616e3fb000113a8d4f',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'car-race',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T07:03:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672643023000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '15,345',
    ...winningsDataSet1
  },
  bgImgSrc: Images.carRacePosterBg,
  titleImgSrc: Images.carRacePosterTitle,
  gameImgSrc: Images.carRacePosterGameImg,
  // game: 'Car Race',
  // gameData: MiniGames.carRace,
  gameType: 'minigame',
  gameDescription1: 'Speed to the finish line &',
  gameDescription2: 'become a champion of the track',
  xpAvailable: '5',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'racing'
};
const boxTower = {
  gameName: 'Box Tower',
  gameImage: Images.boxTowerMinigamePortrait,
  gameImageLandscape: Images.boxTowerMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/box_tower/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/box_tower/box_tower_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '62b422741fb67d001eff20fa',
  gameSlug: 'box-tower',
  contest: {
    _id: '639308502ac3ab001bd19d5a',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'box-tower',
    title: 'Testing With Sony postman collection',
    description: 'Testing With Sony postman collection',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 0,
    entryFee: 0,
    startDate: '2023-01-06T06:53:01.000Z',
    endDate: '2023-01-07T07:23:01.000Z',
    timestampStart: 1672987981000,
    timestampEnd: 1673076181000,
    entryFeeType: 1,
    life: 0,
    doubleScore: 0,
    jumpStart: 0,
    filledTeamSlots: '17,880',
    ...winningsDataSet1
  },
  xpAvailable: '10',
  playedCount: 0,
  bgImgSrc: Images.boxTowerPosterBg,
  titleImgSrc: Images.boxTowerPosterTitle,
  gameImgSrc: Images.boxTowerPosterGameImg,
  // game: MiniGames.boxTower.gameName,
  // gameData: MiniGames.boxTower,
  gameType: 'minigame',
  gameDescription1: 'Rise to the top ',
  gameDescription2: 'in Box Tower!',
  highScore: 5,
  currentScore: 5,
  category: 'puzzles'
};
const fruitDynastyChops = {
  gameId: '63ce25924a363e001d60261b',
  gameImage: Images.fruitDynastyMinigamePortrait,
  gameImageLandscape: Images.fruitDynastyMinigameLandscape,
  createdOn: '2023-01-23T06:13:38.681Z',
  deletedOn: null,
  gameName: 'Fruit Dynasty Chops',
  apiUrl: 'https://api-dev.livegamespro.games',
  gameURL: 'https://games-dev.igamio.com/h2h_chops/',
  addTagId:
    'https://pubads.g.doubleclick.net/gampad/live/ads?iu=/423477888/LIV_Games/CrazyTaxi_Rewards&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',

  portraitVideoUrl: '',
  landscapeVideoUrl: '',
  gameSlug: 'fruit-dynasty-chops',
  ageGroup: 'all',
  gameOrientation: 'landscape',
  ageRating: '10',
  gameAppType: ['63721f88d7050f001d7a86a7'],
  isNewGame: true,
  appType: 'miniGame',

  leaderboard: leaderboardDataSet1,
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'fruit-dynasty',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: 'P vs P',
    ...winningsDataSet1
  },
  playedCount: 0,
  bgImgSrc: Images.fruitDynastyPvpPosterBg,
  titleImgSrc: Images.fruitDynastyPvpPosterTitle,
  gameImgSrc: Images.fruitDynastyPvpPosterGameImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'playerVsPlayer',
  gameDescription1: 'Rule the fruit kingdom ',
  gameDescription2: 'in Fruit Dynasty P v P',
  xpAvailable: '5',
  highScore: 5,
  currentScore: 5,
  category: 'arcade'

  // landscapeBackgroundImageUrl:
  //   'https://asset.livegamespro.games/fruit_dynasty_chop/fruit_dynasty_chop_l_bg.webp'
};
const fruitDynasty = {
  gameName: 'Fruit Dynasty',
  gameImage: Images.fruitDynastyMinigamePortrait,
  gameImageLandscape: Images.fruitDynastyMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/fruit_dynasty/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/fruit_dynasty_chop/fruit_dynasty_chop_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '62bc42fb1fb67d001eff2103',
  gameSlug: 'fruit-dynasty',
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'fruit-dynasty',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,992',
    ...winningsDataSet1
  },
  xpAvailable: '5',
  bgImgSrc: Images.fruitDynastyPosterBg,
  titleImgSrc: Images.fruitDynastyPosterTitle,
  gameImgSrc: Images.fruitDynastyPosterGameImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'minigame',
  gameDescription1: 'Rule the fruit kingdom ',
  gameDescription2: 'in Fruit Dynasty',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};
const cricketBatterChallenge = {
  gameName: 'Cricket Batter Challenge',
  xpAvailable: '15',
  gameImage: Images.batterChallengeMinigamePortrait,
  gameImageLandscape: Images.batterChallengeMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/cricket_batter_challenge/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/cricket_batter_challenge/cricket_batter_challenge_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '63367db7bf89f70020c0828e',
  gameSlug: 'cricket-batter-challenge',
  contest: {
    _id: '63b280a5b3deab0013374cfa',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'cricket-batter-challenge',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:00:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,438'
  },
  bgImgSrc: Images.cricketBatterPosterBg,
  titleImgSrc: Images.cricketBatterPosterTitle,
  gameImgSrc: Images.cricketBatterPosterGameImg,
  // game: MiniGames.cricketBatterChallenge.gameName,
  // gameData: MiniGames.cricketBatterChallenge,
  gameType: 'minigame',
  gameDescription1: 'Step up to the crease &',
  gameDescription2: 'become a cricket champion!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'sports'
};
const lastWicket = {
  gameName: 'Last Wicket',
  xpAvailable: '10',
  gameImage: Images.lastWicketMinigamePortrait,
  gameImageLandscape: Images.lastWicketMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/last_wicket/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/last_wicket/last_wicket_p_bg.webp',
  leaderboard: leaderboardDataSet2,
  gameId: '62d13e6363bc14001e3eaee9',
  gameSlug: 'last-wicket',
  contest: {
    _id: '63b275c70d4d16001bb87ca0',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'last-wicket',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:13:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672640023000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '9,888'
  },
  bgImgSrc: Images.lastWicketPosterBg,
  titleImgSrc: Images.lastWicketPosterTitle,
  gameImgSrc: Images.lastWicketPosterGameImg,
  // game: MiniGames.lastWicket.gameName,
  // gameData: MiniGames.lastWicket,
  gameType: 'minigame',
  gameDescription1: 'Protect your wicket & score',
  gameDescription2: 'big in Last Wicket cricket game!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'sports'
};
const penaltyKicks = {
  gameName: 'Penalty Kicks',
  xpAvailable: '5',
  gameImage: Images.penaltyKicksMinigamePortrait,
  gameImageLandscape: Images.penaltyKicksMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/penalty_kicks/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/quick_maths/quick_maths_p_bg.webp',
  leaderboard: leaderboardDataSet2,
  gameId: '6348f678efbad4001e69287a',
  gameSlug: 'penalty-kicks',
  contest: {
    _id: '63b281167667ce00115cc0b7',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'penalty-kicks',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:01:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642903000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,889'
  },
  bgImgSrc: Images.penaltyKickPosterPosterBg,
  titleImgSrc: Images.penaltyKickPosterPosterTitle,
  gameImgSrc: Images.penaltyKickPosterPosterGameImg,
  // game: MiniGames.penaltyKicks.gameName,
  // gameData: MiniGames.penaltyKicks,
  gameType: 'minigame',
  gameDescription1: 'Score the winning goal in Penalty',
  gameDescription2: 'and become a soccer legend!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'sports'
};
const smallArcher = {
  gameName: 'Small Archer',
  xpAvailable: '5',
  gameImage: Images.smallArcherMinigamePortrait,
  gameImageLandscape: Images.smallArcherMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/small_archer/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/small_archer/small_archer_p_bg.webp',
  leaderboard: leaderboardDataSet2,
  gameId: '6348f5cfefbad4001e692877',
  gameSlug: 'small-archer',
  contest: {
    _id: '63b28202543f4c00129f74b5',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'small-archer',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-03T07:06:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672729603000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '11,987'
  },
  bgImgSrc: Images.smallArcherPosterBg,
  titleImgSrc: Images.smallArcherPosterTitle,
  gameImgSrc: Images.smallArcherPosterGameImg,
  // game: MiniGames.smallArcher.gameName,
  // gameData: MiniGames.smallArcher,
  gameType: 'minigame',
  gameDescription1: 'Test your aim and precision',
  gameDescription2: 'in the Small Archer adventure!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};

const smashTheRock = {
  gameName: 'Smash The Rock',
  xpAvailable: '5',
  gameImage: Images.smashTheRockMinigamePortrait,
  gameImageLandscape: Images.smashTheRockMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/smash_the_rock/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/smash_the_rock/smash_the_rock_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '62bc456c1fb67d001eff2105',
  gameSlug: 'smash-the-rock',
  contest: {
    _id: '63b2751d4add80001cf33661',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'smash-the-rock',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:10:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '18,987'
  },
  bgImgSrc: Images.smashTheRockPosterBg,
  titleImgSrc: Images.smashTheRockPosterTitle,
  gameImgSrc: Images.smashTheRockPosterGameImg,
  // game: MiniGames.smashTheRock.gameName,
  // gameData: MiniGames.smashTheRock,
  gameType: 'minigame',
  gameDescription1: 'Crush the competition',
  gameDescription2: 'in Smash the Rock!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'puzzles'
};
const popUp = {
  gameName: 'Popup',
  xpAvailable: '5',
  gameImage: Images.popUpMinigamePortrait,
  gameImageLandscape: Images.popUpMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/pop_up/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/pop_up/pop_up_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '62d13e1463bc14001e3eaee8',
  gameSlug: 'pop-up',
  contest: {
    _id: '63b27592489966001c0433cc',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'pop-up',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:12:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639963000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '13,890'
  },
  bgImgSrc: Images.popUpPosterBg,
  titleImgSrc: Images.popUpPosterTitle,
  gameImgSrc: Images.popUpPosterGameImg,
  // game: MiniGames.popUp.gameName,
  // gameData: MiniGames.popUp,
  gameType: 'minigame',
  gameDescription1: 'Pop your way ',
  gameDescription2: 'to the top!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'puzzles'
};
const numberSnake = {
  gameName: 'Number Snake',
  xpAvailable: '5',
  gameImage: Images.numberSnakeMinigamePortrait,
  gameImageLandscape: Images.numberSnakeMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/number_snake/',
  gameBackgroundImgUrl: '',
  leaderboard: leaderboardDataSet3,
  gameId: '63205a4417fe970020c0e1f6',
  gameSlug: 'number-snake',
  contest: {
    _id: '63b280714c0c3d0011c9944e',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'number-snake',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:00:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '16,837'
  },
  bgImgSrc: Images.numberSnakePosterBg,
  titleImgSrc: Images.numberSnakePosterTitle,
  gameImgSrc: Images.numberSnakePosterGameImg,
  // game: 'numberSnake',
  // gameData: MiniGames.numberSnake,
  gameType: 'minigame',
  gameDescription1: 'Slither your way to high scores',
  gameDescription2: 'in the Number Snake puzzle!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'quiz'
};
const quickMaths = {
  gameName: 'Quick Maths',
  xpAvailable: '5',
  gameImage: Images.quickMathsMinigamePortrait,
  gameImageLandscape: Images.quickMathsMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/quick_maths/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/quick_maths/quick_maths_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '632059e717fe970020c0e1f5',
  gameSlug: 'quick-maths',
  contest: {
    _id: '63b280306c08d600121485a7',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'quick-maths',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:58:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,723'
  },
  bgImgSrc: Images.quickMathsPosterBg,
  titleImgSrc: Images.quickMathsPosterTitle,
  gameImgSrc: Images.quickMathsPosterGameImg,
  // game: 'quickMaths',
  // gameData: MiniGames.quickMaths,
  gameType: 'minigame',
  gameDescription1: 'Sharpen your mind & improve',
  gameDescription2: ' your math skills with Quick Math!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'quiz'
};

///new
const cidBikeRider = {
  gameName: 'CID Bike Rider',
  xpAvailable: '5',
  gameImage: Images.cidBikeRiderMinigamePortrait,
  gameImageLandscape: Images.cidBikeRiderMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/cid_bike_rider/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/quick_maths/quick_maths_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '632059e717fe970020c0e1f5',
  gameSlug: 'cid_bike_rider',
  contest: {
    _id: '63b280306c08d600121485a7',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'cid_bike_rider',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:58:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,723'
  },
  bgImgSrc: Images.cidBikeRiderPosterBg,
  titleImgSrc: Images.cidBikeRiderPosterTitle,
  gameImgSrc: Images.cidBikeRiderPosterGameImg,
  // game: 'quickMaths',
  // gameData: MiniGames.quickMaths,
  gameType: 'minigame',
  gameDescription1: 'Cruising with pride',
  gameDescription2: 'Keeping crime in defeat!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'racing'
};
const honeyBunnyJump = {
  gameName: 'Honey Bunny Jump',
  xpAvailable: '5',
  gameImage: Images.honeyBunnyJumpMinigamePortrait,
  gameImageLandscape: Images.honeyBunnyJumpMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/honey_bunny_jump/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/small_archer/small_archer_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '6348f5cfefbad4001e692877',
  gameSlug: 'honey_bunny_jump',
  contest: {
    _id: '63b28202543f4c00129f74b5',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'honey_bunny_jump',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-03T07:06:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672729603000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '11,987'
  },
  bgImgSrc: Images.honeyBunnyJumpPosterBg,
  titleImgSrc: Images.honeyBunnyJumpPosterTitle,
  gameImgSrc: Images.honeyBunnyJumpPosterGameImg,
  // game: MiniGames.smallArcher.gameName,
  // gameData: MiniGames.smallArcher,
  gameType: 'minigame',
  gameDescription1: 'Hop with joy, bounce with glee',
  gameDescription2: 'fun for you and me!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};
const honeyBunnyRiseUp = {
  gameName: 'Honey Bunny Rise Up',
  xpAvailable: '5',
  gameImage: Images.honeyBunnyRiseUpMinigamePortrait,
  gameImageLandscape: Images.honeyBunnyRiseUpMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/honey_bunny_rise_up/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/small_archer/small_archer_p_bg.webp',
  leaderboard: leaderboardDataSet2,
  gameId: '6348f5cfefbad4001e692877',
  gameSlug: 'honey_bunny_jump',
  contest: {
    _id: '63b28202543f4c00129f74b5',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'honey_bunny_rise_up',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-03T07:06:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672729603000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '11,987'
  },
  bgImgSrc: Images.honeyBunnyRiseUpPosterBg,
  titleImgSrc: Images.honeyBunnyRiseUpPosterTitle,
  gameImgSrc: Images.honeyBunnyRiseUpPosterGameImg,
  // game: MiniGames.smallArcher.gameName,
  // gameData: MiniGames.smallArcher,
  gameType: 'minigame',
  gameDescription1: 'Rise up high',
  gameDescription2: 'Reach for the sky',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};
const goldMiner = {
  gameName: 'Gold Miner',
  xpAvailable: '5',
  gameImage: Images.goldMinerMinigamePortrait,
  gameImageLandscape: Images.goldMinerMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/gold_miner/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/small_archer/small_archer_p_bg.webp',
  leaderboard: leaderboardDataSet2,
  gameId: '6348f5cfefbad4001e692877',
  gameSlug: 'gold_miner',
  contest: {
    _id: '63b28202543f4c00129f74b5',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'gold_miner',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-03T07:06:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672729603000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '11,987'
  },
  bgImgSrc: Images.goldMinerPosterBg,
  titleImgSrc: Images.goldMinerPosterTitle,
  gameImgSrc: Images.goldMinerPosterGameImg,
  // game: MiniGames.smallArcher.gameName,
  // gameData: MiniGames.smallArcher,
  gameType: 'minigame',
  gameDescription1: 'The thrill of the bling',
  gameDescription2: 'Strike it rich with every swing!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};
const dayaAirShooter = {
  gameName: 'Daya Air Shooter',
  gameImage: Images.dayaAirShooterMinigamePortrait,
  gameImageLandscape: Images.dayaAirShooterMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/daya_air_shooter/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/fruit_dynasty_chop/fruit_dynasty_chop_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '62bc42fb1fb67d001eff2103',
  gameSlug: 'daya_air_shooter',
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'daya_air_shooter',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,992',
    ...winningsDataSet1
  },
  xpAvailable: '5',
  bgImgSrc: Images.dayaAirShooterPosterBg,
  titleImgSrc: Images.dayaAirShooterPosterTitle,
  gameImgSrc: Images.dayaAirShooterPosterGameImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'minigame',
  gameDescription1: 'In the air and on',
  gameDescription2: 'the move targets groove!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};
const classicBowling = {
  gameName: 'Classic Bowling',
  xpAvailable: '5',
  gameImage: Images.classicBowlingMinigamePortrait,
  gameImageLandscape: Images.classicBowlingMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/classic_bowling/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/quick_maths/quick_maths_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '6348f678efbad4001e69287a',
  gameSlug: 'classic_bowling',
  contest: {
    _id: '63b281167667ce00115cc0b7',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'classic_bowling',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:01:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642903000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,889'
  },
  bgImgSrc: Images.classicBowlingPosterBg,
  titleImgSrc: Images.classicBowlingPosterTitle,
  gameImgSrc: Images.classicBowlingPosterGameImg,
  // game: MiniGames.classicBowling.gameName,
  // gameData: MiniGames.penaltyKicks,
  gameType: 'minigame',
  gameDescription1: 'Bowl your heart out,',
  gameDescription2: 'Aim for the strike!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'sports'
};

const duckShooter = {
  gameName: 'Duck Shooter',
  gameImage: Images.duckShooterMinigamePortrait,
  gameImageLandscape: Images.duckShooterMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/duck_shooter/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/fruit_dynasty_chop/fruit_dynasty_chop_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '62bc42fb1fb67d001eff2103',
  gameSlug: 'duck_shooter',
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'duck_shooter',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,992',
    ...winningsDataSet1
  },
  xpAvailable: '5',
  bgImgSrc: Images.duckShooterPosterBg,
  titleImgSrc: Images.duckShooterPosterTitle,
  gameImgSrc: Images.duckShooterPosterGameImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'minigame',
  gameDescription1: 'Take aim and shoot with glee',
  gameDescription2: 'fun for you and me!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};
const brickBreaker = {
  gameName: 'Brick Breaker',
  xpAvailable: '5',
  gameImage: Images.brickBreakerMinigamePortrait,
  gameImageLandscape: Images.brickBreakerMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/brick_breaker/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/brick_breaker/brick_breaker_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '62d13e1463bc14001e3eaee8',
  gameSlug: 'brick_breaker',
  contest: {
    _id: '63b27592489966001c0433cc',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'brick_breaker',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:12:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639963000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '13,890'
  },
  bgImgSrc: Images.brickBreakerPosterBg,
  titleImgSrc: Images.brickBreakerPosterTitle,
  gameImgSrc: Images.brickBreakerPosterGameImg,
  // game: MiniGames.popUp.gameName,
  // gameData: MiniGames.popUp,
  gameType: 'minigame',
  gameDescription1: 'Break those bricks',
  gameDescription2: 'and watch them fall',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'puzzles'
};

const shootRobbers = {
  gameName: 'Shoot Robbers',
  xpAvailable: '5',
  gameImage: Images.shootRobbersMinigamePortrait,
  gameImageLandscape: Images.shootRobbersMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/shoot_robbers/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/shoot_robbers/shoot_robbers_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '6348f5cfefbad4001e692877',
  gameSlug: 'shoot_robbers',
  contest: {
    _id: '63b28202543f4c00129f74b5',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'shoot_robbers',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-03T07:06:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672729603000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '11,987'
  },
  bgImgSrc: Images.shootRobbersPosterBg,
  titleImgSrc: Images.shootRobbersPosterTitle,
  gameImgSrc: Images.shootRobbersPosterGameImg,
  // game: MiniGames.smallArcher.gameName,
  // gameData: MiniGames.smallArcher,
  gameType: 'minigame',
  gameDescription1: 'Protect take aim and fire',
  gameDescription2: 'justice you will inspire!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};

const cricketFielderChallenge = {
  gameName: 'Cricket Fielder Challenge',
  xpAvailable: '15',
  gameImage: Images.cricketFielderChallengeMinigamePortrait,
  gameImageLandscape: Images.cricketFielderChallengeMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/cricket_fielder_challenge/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/cricket_fielder_challenge/cricket_fielder_challenge_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '63367db7bf89f70020c0828e',
  gameSlug: 'cricket_fielder_challenge',
  contest: {
    _id: '63b280a5b3deab0013374cfa',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'cricket_fielder_challenge',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:00:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,438'
  },
  bgImgSrc: Images.cricketFielderChallengePosterBg,
  titleImgSrc: Images.cricketFielderChallengePosterTitle,
  gameImgSrc: Images.cricketFielderChallengePosterGameImg,
  // game: MiniGames.cricketBatterChallenge.gameName,
  // gameData: MiniGames.cricketBatterChallenge,
  gameType: 'minigame',
  gameDescription1: 'Field like a pro, catch every ball',
  gameDescription2: 'give it your all!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'sports'
};
const colorBricks = {
  gameName: 'Color Brick',
  xpAvailable: '5',
  gameImage: Images.colorBricksMinigamePortrait,
  gameImageLandscape: Images.colorBricksMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/color_bricks/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/color_bricks/color_bricks_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '62d13e1463bc14001e3eaee8',
  gameSlug: 'color_bricks',
  contest: {
    _id: '63b27592489966001c0433cc',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'color_bricks',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:12:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639963000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '13,890'
  },
  bgImgSrc: Images.colorBricksPosterBg,
  titleImgSrc: Images.colorBricksPosterTitle,
  gameImgSrc: Images.colorBricksPosterGameImg,
  // game: MiniGames.popUp.gameName,
  // gameData: MiniGames.popUp,
  gameType: 'minigame',
  gameDescription1: 'Match the colors, clear the board',
  gameDescription2: 'endless fun in store!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'puzzles'
};
const baseBallPro = {
  gameName: 'Baseball Pro',
  xpAvailable: '15',
  gameImage: Images.baseBallProMinigamePortrait,
  gameImageLandscape: Images.baseBallProMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/baseball_pro/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/baseball_pro/baseball_pro_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '63367db7bf89f70020c0828e',
  gameSlug: 'baseball_pro',
  contest: {
    _id: '63b280a5b3deab0013374cfa',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'baseball_pro',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:00:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,438'
  },
  bgImgSrc: Images.baseBallProPosterBg,
  titleImgSrc: Images.baseBallProPosterTitle,
  gameImgSrc: Images.baseBallProPosterGameImg,
  // game: MiniGames.cricketBatterChallenge.gameName,
  // gameData: MiniGames.cricketBatterChallenge,
  gameType: 'minigame',
  gameDescription1: 'Swing for the fences',
  gameDescription2: 'aim for the stars!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'sports'
};

const trafficCommand = {
  gameName: 'Traffic Command',
  xpAvailable: '15',
  gameImage: Images.trafficCommandMinigamePortrait,
  gameImageLandscape: Images.trafficCommandMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/traffic_command/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/traffic_command/traffic_command_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '63367db7bf89f70020c0828e',
  gameSlug: 'traffic_command',
  contest: {
    _id: '63b280a5b3deab0013374cfa',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'traffic_command',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:00:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,438'
  },
  bgImgSrc: Images.trafficCommandPosterBg,
  titleImgSrc: Images.trafficCommandPosterTitle,
  gameImgSrc: Images.trafficCommandPosterGameImg,
  // game: MiniGames.cricketBatterChallenge.gameName,
  // gameData: MiniGames.cricketBatterChallenge,
  gameType: 'minigame',
  gameDescription1: 'Stop and go, keep it flow',
  gameDescription2: 'the citys show!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'strategy'
};

const babesKitchen = {
  gameName: 'Babes Kitchen',
  xpAvailable: '15',
  gameImage: Images.babesKitchenMinigamePortrait,
  gameImageLandscape: Images.babesKitchenMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/babes_kitchen/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/babes_kitchen/babes_kitchen_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '63367db7bf89f70020c0828e',
  gameSlug: 'babes_kitchen',
  contest: {
    _id: '63b280a5b3deab0013374cfa',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'babes_kitchen',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T07:00:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642843000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '7,438'
  },
  bgImgSrc: Images.babesKitchenPosterBg,
  titleImgSrc: Images.babesKitchenPosterTitle,
  gameImgSrc: Images.babesKitchenPosterGameImg,
  // game: MiniGames.cricketBatterChallenge.gameName,
  // gameData: MiniGames.cricketBatterChallenge,
  gameType: 'minigame',
  gameDescription1: 'Spice it up, cook with love',
  gameDescription2: 'food from above!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'strategy'
};

const crazyTaxi = {
  gameName: 'Crazy Taxi',
  xpAvailable: '5',
  gameImage: Images.crazyTaxiMinigamePortrait,
  gameImageLandscape: Images.crazyTaxiMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/crazy_taxi/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/quick_maths/quick_maths_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '632059e717fe970020c0e1f5',
  gameSlug: 'crazy_taxi',
  contest: {
    _id: '63b280306c08d600121485a7',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'crazy_taxi',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:58:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,723'
  },
  bgImgSrc: Images.crazyTaxiPosterBg,
  titleImgSrc: Images.crazyTaxiPosterTitle,
  gameImgSrc: Images.crazyTaxiPosterGameImg,
  // game: 'quickMaths',
  // gameData: MiniGames.quickMaths,
  gameType: 'minigame',
  gameDescription1: 'Speeding through the city',
  gameDescription2: 'catch a ride if you are wise',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'racing'
};
const ticTacToe = {
  gameId: '63ce25924a363e001d60261b',
  gameImage: Images.ticTacToeMinigamePortrait,
  gameImageLandscape: Images.ticTacToeMinigameLandscape,
  createdOn: '2023-01-23T06:13:38.681Z',
  deletedOn: null,
  gameName: 'Tic Tac Toe',
  apiUrl: 'https://api-dev.livegamespro.games',
  gameURL: 'https://games-dev.igamio.com/h2h_tic_tac_toe/',
  addTagId:
    'https://pubads.g.doubleclick.net/gampad/live/ads?iu=/423477888/LIV_Games/CrazyTaxi_Rewards&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',

  portraitVideoUrl: '',
  landscapeVideoUrl: '',
  gameSlug: 'h2h_tic_tac_toe',
  ageGroup: 'all',
  gameOrientation: 'landscape',
  ageRating: '10',
  gameAppType: ['63721f88d7050f001d7a86a7'],
  isNewGame: true,
  appType: 'miniGame',

  leaderboard: leaderboardDataSet2,
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'h2h_tic_tac_toe',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: 'P vs P',
    ...winningsDataSet1
  },
  playedCount: 0,
  bgImgSrc: Images.ticTacToePosterBg,
  titleImgSrc: Images.ticTacToePosterTitle,
  gameImgSrc: Images.ticTacToePosterGameImg,
  gameType: 'playerVsPlayer',
  gameDescription1: 'Xs and 0s, a game of wits',
  gameDescription2: 'may the best win it!',
  xpAvailable: '5',
  highScore: 5,
  currentScore: 5,
  category: 'strategy'
};

const frogStatic = {
  gameName: 'Frog Static',
  xpAvailable: '5',
  gameImage: Images.frogStaticMinigamePortrait,
  gameImageLandscape: Images.frogStaticMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/frogtastic/',
  gameBackgroundImgUrl: 'https://asset.livegamespro.games/small_archer/small_archer_p_bg.webp',
  leaderboard: leaderboardDataSet1,
  gameId: '6348f5cfefbad4001e692877',
  gameSlug: 'frogtastic',
  contest: {
    _id: '63b28202543f4c00129f74b5',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'frogtastic',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-03T07:06:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672729603000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '11,987'
  },
  bgImgSrc: Images.frogStaticPosterBg,
  titleImgSrc: Images.frogStaticPosterTitle,
  gameImgSrc: Images.frogStaticPosterGameImg,
  // game: MiniGames.smallArcher.gameName,
  // gameData: MiniGames.smallArcher,
  gameType: 'minigame',
  gameDescription1: 'Match and clear the pond,',
  gameDescription2: 'a puzzle game beyond!',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};

const quickMathsPvp = {
  gameId: '63ce25924a363e001d60261b',
  gameImage: Images.quickMathsPvpMinigamePortrait,
  gameImageLandscape: Images.quickMathsPvpMinigameLandscape,
  createdOn: '2023-01-23T06:13:38.681Z',
  deletedOn: null,
  gameName: 'Quick Maths',
  apiUrl: 'https://api-dev.livegamespro.games',
  gameURL: 'https://games-dev.igamio.com/h2h_maths_challenge/',
  addTagId:
    'https://pubads.g.doubleclick.net/gampad/live/ads?iu=/423477888/LIV_Games/CrazyTaxi_Rewards&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',

  portraitVideoUrl: '',
  landscapeVideoUrl: '',
  gameSlug: 'h2h_maths_challenge',
  ageGroup: 'all',
  gameOrientation: 'landscape',
  ageRating: '10',
  gameAppType: ['63721f88d7050f001d7a86a7'],
  isNewGame: true,
  appType: 'miniGame',

  leaderboard: leaderboardDataSet1,
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'fruit-dynasty',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: 'P vs P',
    ...winningsDataSet1
  },
  playedCount: 0,
  bgImgSrc: Images.quickMathsPvpPosterBg,
  titleImgSrc: Images.quickMathsPvpPosterTitle,
  gameImgSrc: Images.quickMathsPvpPosterGameImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'playerVsPlayer',
  gameDescription1: 'Think fast, solve quick',
  gameDescription2: 'the ultimate math trick!',
  xpAvailable: '5',
  highScore: 5,
  currentScore: 5,
  category: 'quiz'
};

const triviaQuiz = {
  gameName: 'Trivia Quiz',
  xpAvailable: '5',
  gameImage: Images.triviaQuizMinigamePortrait,
  gameImageLandscape: Images.triviaQuizMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/bollywood_trivia_quiz/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/bollywood_trivia_quiz/bollywood_trivia_quiz_p_bg.webp',
  leaderboard: leaderboardDataSet2,
  gameId: '632059e717fe970020c0e1f5',
  gameSlug: 'bollywood_trivia_quiz',
  contest: {
    _id: '63b280306c08d600121485a7',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'bollywood_trivia_quiz',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    winningsAmount: 200000,
    gemWinningsAmount: 60,
    entryFee: 0,
    winningsPerPosition: {
      '1': {
        '10000': 1,
        '20000': 2,
        '50000': 1,
        '100000': 1
      },
      '2': {
        '5': 2,
        '20': 1,
        '30': 1
      }
    },
    startDate: '2023-01-02T06:58:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672642723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,723'
  },
  bgImgSrc: Images.triviaQuizPosterBg,
  titleImgSrc: Images.triviaQuizPosterTitle,
  gameImgSrc: Images.triviaQuizPosterGameImg,
  // game: 'quickMaths',
  // gameData: MiniGames.quickMaths,
  gameType: 'minigame',
  gameDescription1: 'Test your knowledge',
  gameDescription2: 'take the lead',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'quiz'
};

const rescueRocket = {
  gameName: 'Rescue Rocket',
  gameImage: Images.rescueRocketMinigamePortrait,
  gameImageLandscape: Images.rescueRocketMinigameLandscape,
  gameURL: 'https://games-dev.igamio.com/rescue_game_engine/',
  gameBackgroundImgUrl:
    'https://asset.livegamespro.games/fruit_dynasty_chop/fruit_dynasty_chop_p_bg.webp',
  leaderboard: leaderboardDataSet3,
  gameId: '62bc42fb1fb67d001eff2103',
  gameSlug: 'rescue_game_engine',
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'rescue_game_engine',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: '8,992',
    ...winningsDataSet1
  },
  xpAvailable: '5',
  bgImgSrc: Images.rescueRocketPosterBg,
  titleImgSrc: Images.rescueRocketPosterTitle,
  gameImgSrc: Images.rescueRocketPosterGameImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'minigame',
  gameDescription1: 'come what may',
  gameDescription2: 'Blast off to save the day !',
  playedCount: 0,
  highScore: 5,
  currentScore: 5,
  category: 'arcade'
};

const ludoPvp = {
  gameId: '63ce25924a363e001d60261b',
  gameImage: Images.ludoPortrait,
  gameImageLandscape: Images.ludoLandscape,
  createdOn: '2023-01-23T06:13:38.681Z',
  deletedOn: null,
  gameName: 'Ludo',
  apiUrl: 'https://api-dev.livegamespro.games',
  gameURL: 'https://games-dev.igamio.com/h2h_ludo/',
  addTagId:
    'https://pubads.g.doubleclick.net/gampad/live/ads?iu=/423477888/LIV_Games/CrazyTaxi_Rewards&tfcd=0&npa=0&sz=640x480&gdfp_req=1&output=vast&unviewed_position_start=1&env=vp&impl=s&correlator=',

  portraitVideoUrl: '',
  landscapeVideoUrl: '',
  gameSlug: 'h2h_ludo',
  ageGroup: 'all',
  gameOrientation: 'landscape',
  ageRating: '10',
  gameAppType: ['63721f88d7050f001d7a86a7'],
  isNewGame: true,
  appType: 'miniGame',

  leaderboard: leaderboardDataSet1,
  contest: {
    _id: '63b27470d122f8001dacf6ab',
    contestTypeId: '62b3fd97909c3683de42cad5',
    game: 'ludo',
    title: 'Lets Play Games',
    description: 'Lets Play',
    maximumPlayers: 1000000,
    maxTeamPerUser: 100,
    gemWinningsAmount: 60,
    entryFee: 0,

    startDate: '2023-01-02T06:08:43.000Z',
    endDate: '2023-01-06T15:33:43.000Z',
    timestampStart: 1672639723000,
    timestampEnd: 1673019223000,
    entryFeeType: 1,
    life: 1,
    doubleScore: 1,
    jumpStart: 0,
    filledTeamSlots: 'P vs P',
    ...winningsDataSet1
  },
  playedCount: 0,
  bgImgSrc: Images.ludoBg,
  titleImgSrc: Images.ludoTitle,
  gameImgSrc: Images.ludoImg,
  // game: MiniGames.fruitDynasty.gameName,
  // gameData: MiniGames.fruitDynasty,
  gameType: 'playerVsPlayer',
  gameDescription1: 'Think fast, solve quick',
  gameDescription2: 'the ultimate math trick!',
  xpAvailable: '5',
  highScore: 5,
  currentScore: 5,
  category: 'quiz'
};

const miniGamesList = [
  carRace,
  fruitDynastyChops,
  fruitDynasty,
  cricketBatterChallenge,
  penaltyKicks,
  quickMaths,
  smallArcher,
  lastWicket,
  popUp,
  smashTheRock,
  numberSnake,
  boxTower,
  // cidBikeRider,
  honeyBunnyJump,
  honeyBunnyRiseUp,
  goldMiner,
  // dayaAirShooter,
  classicBowling,
  duckShooter,
  // brickBreaker,
  colorBricks,
  cricketFielderChallenge,
  shootRobbers,
  baseBallPro,
  trafficCommand,
  // babesKitchen,
  // crazyTaxi,
  ticTacToe,
  frogStatic,
  quickMathsPvp,
  triviaQuiz,
  rescueRocket,
  ludoPvp
];

const strategyGameList = [trafficCommand, babesKitchen, ticTacToe, ludoPvp];

const racingGamesList = [
  carRace
  // cidBikeRider
];

const sportsMinigamesList = [
  cricketBatterChallenge,
  lastWicket,
  penaltyKicks,
  classicBowling,
  cricketFielderChallenge,
  baseBallPro
];

const arcadeGamesList = [
  smallArcher,
  fruitDynasty,
  fruitDynastyChops,
  honeyBunnyJump,
  honeyBunnyRiseUp,
  goldMiner,
  // dayaAirShooter,
  duckShooter,
  shootRobbers,
  frogStatic,
  rescueRocket
];

const puzzleGamesList = [
  boxTower,
  smashTheRock,
  popUp,
  // brickBreaker,
  colorBricks
];

const quizGamesList = [numberSnake, quickMaths, quickMathsPvp, triviaQuiz];
const fantasyCricket = {
  gameName: 'Fantasy Cricket',
  gameImage: Images.fantasyCricketImg,
  gameBackgroundImgUrl: Images.fantasyCricketBg,
  contest: {
    filledTeamSlots: '15,765'
  },
  bgImgSrc: Images.fantasyCricketPosterBg,
  titleImgSrc: Images.fantasyCricketPosterTitle,
  gameImgSrc: Images.fantasyCricketPosterGameImg,
  game: 'cricket',
  gameDescription1: 'Build your team & dominate',
  gameDescription2: 'the pitch in Fantasy Cricket!'
};
const fantasyYesNo = {
  bgImgSrc: Images.yesNoFantasyPosterBg,
  titleImgSrc: Images.yesNoFantasyPosterTitle,
  gameImgSrc: Images.yesNoFantasyPosterGameImg,
  game: 'yesorno',
  gameName: 'yesorno',
  gameDescription1: 'Predict Yes/No',
  gameDescription2: 'and WIN BIG!'
};
const fantasyFootball = {
  gameName: 'Fantasy Football',
  gameImage: Images.fantasyCricketImg,
  gameBackgroundImgUrl: Images.fantasyCricketBg,
  contest: {
    filledTeamSlots: '15,765'
  },
  bgImgSrc: Images.fantasyFootballPosterBg,
  titleImgSrc: Images.fantasyFootballPosterTitle,
  gameImgSrc: Images.fantasyFootballPosterGameImg,
  game: 'football',
  gameDescription1: 'Draft your ultimate team &',
  gameDescription2: 'score big in Fantasy Football!'
};
const leaderBoardGame = {
  gameName: 'LeaderBoard Games',
  gameImage: Images.fantasyCricketImg,
  gameBackgroundImgUrl: Images.leaderBoardGameBg,
  contest: {
    filledTeamSlots: '15,765'
  },
  bgImgSrc: Images.leaderBoardGameBg,
  titleImgSrc: Images.leaderBoardGameTitle,
  gameImgSrc: Images.leaderBoardGameimg,
  game: 'leaderboard',
  gameDescription1: 'Compete with the best & ',
  gameDescription2: 'become the ultimate champion!'
};

const pvpGame = {
  gameName: 'Pvp Games',
  gameImage: Images.fantasyCricketImg,
  gameBackgroundImgUrl: Images.pvpGameBg,
  contest: {
    filledTeamSlots: '15,765'
  },
  bgImgSrc: Images.pvpGameBg,
  titleImgSrc: Images.pvpGameTitle,
  gameImgSrc: Images.pvpGameimg,
  game: 'pvp',
  gameDescription1: 'Compete against other players & ',
  gameDescription2: 'conquer the competition!'
};

const newGamesList: any = [
  ludoPvp,
  ...cardsGame,
  fantasyCricket,
  fantasyFootball,
  fantasyYesNo,
  leaderBoardGame,
  pvpGame
];

//add back chops in newgames after

export default {
  cardsGame: cardsGame,
  carRace: carRace,
  boxTower: boxTower,
  fruitDynasty: fruitDynasty,
  cricketBatterChallenge: cricketBatterChallenge,
  lastWicket: lastWicket,
  penaltyKicks: penaltyKicks,
  smallArcher: smallArcher,
  smashTheRock: smashTheRock,
  popUp: popUp,
  numberSnake: numberSnake,
  quickMaths: quickMaths,
  miniGamesList: miniGamesList,
  racingGamesList: racingGamesList,
  sportsMinigamesList: sportsMinigamesList,
  arcadeGamesList: arcadeGamesList,
  puzzleGamesList: puzzleGamesList,
  quizGamesList: quizGamesList,
  strategyGameList: strategyGameList,
  newGamesList: newGamesList,
  cidBikeRider: cidBikeRider,
  honeyBunnyJump: honeyBunnyJump,
  honeyBunnyRiseUp: honeyBunnyRiseUp,
  goldMiner: goldMiner,
  dayaAirShooter: dayaAirShooter,
  classicBowling: classicBowling,
  duckShooter: duckShooter,
  brickBreaker: brickBreaker,
  colorBricks: colorBricks,
  cricketFielderChallenge: cricketFielderChallenge,
  shootRobbers: shootRobbers,
  baseBallPro: baseBallPro,
  trafficCommand: trafficCommand,
  babesKitchen: babesKitchen,
  crazyTaxi: crazyTaxi,
  ticTacToe: ticTacToe,
  frogStatic: frogStatic,
  quickMathsPvp: quickMathsPvp,
  triviaQuiz: triviaQuiz,
  rescueRocket: rescueRocket
};
